import React, { Component } from 'react';
import Table5_6_1 from "./5-6-1";
import Table5_6_2 from "./5-6-2";

export class index extends Component {
  render() {
    return (
      <div>
            <Table5_6_1 {...this.props} />
            <Table5_6_2 {...this.props} />
      </div>
    )
  }
};

export default index;



// WEBPACK FOOTER //
// ./src/components/table/5.0/5-6/index.js